import styled from 'styled-components';

export default styled.div`
  display: flex;
  .smaller {
    max-width: 80px;
    margin-right: ${({ theme }) => theme.spacing * 2}px;
  }
  > * {
    flex-grow: 1;
  }
`;
